import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Node } from '@aptsi-types';
import { ErrorHandlingService } from '../../shared/errorHandling/errorHandling.service';
import { API_ENDPOINTS } from '../../ada-access-api-endpoints';

interface GetNodeResponse {
  node: Node;
}

@Injectable({
  providedIn: 'root'
})
export class NodeService {
  private nodeUrl = environment.apiUrl;

  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) { }

  getNode(rulesetId: string): Observable<Node> {
    return this.http.post<GetNodeResponse>(`${this.nodeUrl}${API_ENDPOINTS.NODE.GET}`, { rulesetId })
      .pipe(
        map(response => response.node),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  getNodeByNodeId(nodeId: string): Observable<Node> {
    return this.http.post<GetNodeResponse>(`${this.nodeUrl}${API_ENDPOINTS.NODE.GET_BY_NODE_ID}`, { nodeId })
      .pipe(
        map(response => response.node),
        catchError(error => this.errorHandlingService.handleError(error))
      );
  }

  updateNode(
    nodeId: string ,
    childId: string,
    parentId: number,
  ): Observable<Node> {
    return this.http.post<Node>(`${this.nodeUrl}${API_ENDPOINTS.NODE.UPDATE}`, {
      nodeId,
      childId,
      parentId
    }).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }

  deleteNode(nodeId: string): Observable<Node> {
    return this.http.post<Node>(`${this.nodeUrl}${API_ENDPOINTS.NODE.DELETE}`, { nodeId }).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }

  createNode(
   // nodeId: number,
    ruleId: string,
    ruleSetId:string,
    childId: string,
    parentId: string,
  ): Observable<Node> {
    return this.http.post<Node>(`${this.nodeUrl}${API_ENDPOINTS.NODE.CREATE}`, {
     // nodeId,
      ruleId,
      ruleSetId,
      childId,
      parentId
    }).pipe(
      catchError(error => this.errorHandlingService.handleError(error))
    );
  }
}
